import { BaselineWithExperiencesEntry, Entry, ExperienceMapper } from "@ninetailed/experience.js-utils-contentful";

// import { SettingsContext } from './SettingsProvider';
// import { useContext } from 'react';
// import { useExperience } from '@ninetailed/experience.js-next';

export type singularBlock = Entry | BaselineWithExperiencesEntry;
export type singularOrArrayBlock = singularBlock | Entry[] | BaselineWithExperiencesEntry[];

export const hasExperiences = (entry: singularBlock): entry is BaselineWithExperiencesEntry => {
  return (entry as BaselineWithExperiencesEntry)?.nt_experiences !== undefined;
};

export const parseExperiences = (entry: any) => {
  // console.log("parseExperiencesparseExperiencesparseExperiencesparseExperiences", entry);
  return hasExperiences(entry)
    ? entry?.nt_experiences
        .filter((experience) => ExperienceMapper.isExperienceEntry(experience))
        .map((experience) => ExperienceMapper.mapExperience(experience))
    : [];
};

// TODO: Handle useContext example with app router
// export const hoistId = (entry: singularBlock) => {
//   return {
//     ...entry,
//     id: entry.sys.id,
//   };
// };

// // Feature flagging example
// export const useFlag = (flag: string) => {
//   const settings = useContext(SettingsContext);
//   const setting = settings[flag] || {};

//   const { variantIndex } = useExperience({
//     baseline: hoistId(setting),
//     experiences: parseExperiences(setting),
//   });

//   return variantIndex;
// };

export const parseCustomExperience = (item: any) => {
  if (item?.nt_experiences && Array.isArray(item.nt_experiences)) {
    // console.log("Raw nt_experiences for item:", item, item.id, item.nt_experiences);
    // Transform experiences to match Contentful structure
    const transformedExperiences = item.nt_experiences.map((experience: any) => ({
      sys: {
        id: experience.id,
        type: "Entry",
        contentType: {
          sys: {
            id: "nt_experience",
            type: "ContentType",
            linkType: "ContentType",
          },
        },
      },
      fields: {
        nt_name: experience.nt_name,
        nt_description: experience.nt_description,
        nt_type: experience.nt_type,
        nt_config: experience.nt_config,
        nt_audience: experience.nt_audience
          ? {
              sys: {
                id: experience.nt_audience.nt_audience_id || experience.nt_audience.id,
                type: "Entry",
                contentType: {
                  sys: {
                    id: "nt_audience",
                    type: "ContentType",
                    linkType: "ContentType",
                  },
                },
              },
              fields: {
                nt_name: experience.nt_audience.nt_name,
                nt_rules: experience.nt_audience.nt_rules,
                nt_audience_id: experience.nt_audience.nt_audience_id,
                nt_metadata: experience.nt_audience.nt_metadata,
              },
            }
          : undefined,
        nt_variants: experience.nt_variants
          ? experience.nt_variants.map((variant: any) => ({
              sys: {
                id: variant.id,
                type: "Entry",
                contentType: {
                  sys: {
                    id: variant.type || "menuItem",
                    type: "ContentType",
                    linkType: "ContentType",
                  },
                },
              },
              fields: {
                ...variant,
              },
            }))
          : undefined,
        nt_experience_id: experience.nt_experience_id,
        nt_metadata: experience.nt_metadata,
      },
    }));
    // console.log("Transformed experiences for item:", item.id, transformedExperiences);
    const mappedExperiences = transformedExperiences
      .map((experience: any) => {
        try {
          return ExperienceMapper.mapExperience(experience);
        } catch (error) {
          // console.error("Error mapping experience:", experience, error);
          // Fallback to raw experience if mapping fails
          return {
            id: experience.sys.id,
            name: experience.fields.nt_name,
            type: experience.fields.nt_type,
            config: experience.fields.nt_config,
            audience: experience.fields.nt_audience
              ? {
                  id: experience.fields.nt_audience.sys.id,
                  name: experience.fields.nt_audience.fields.nt_name,
                  rules: experience.fields.nt_audience.fields.nt_rules,
                }
              : undefined,
            variants: experience.fields.nt_variants
              ? experience.fields.nt_variants.map((variant: any) => ({
                  id: variant.sys.id,
                  ...variant.fields,
                }))
              : [],
            experienceId: experience.fields.nt_experience_id,
            metadata: experience.fields.nt_metadata,
          };
        }
      })
      .filter((exp: any) => exp !== null);
    // console.log("Parsed experiences for item:", item.id, mappedExperiences);
    return mappedExperiences;
  }
  // console.log("No nt_experiences for item:", item.id);
  return [];
};
